import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth"

export async function getLineAuth(): Promise<boolean> {
  let user = await getCurrentUser()
  if (user) {
    const idTokenResult = await getAuth().currentUser.getIdTokenResult()
    if (idTokenResult.claims.lineAuth as boolean) {
      return true
    }
  }

  const searchParams = new URLSearchParams(location.search)
  if (searchParams.has("code") && searchParams.has("state")) {
    return true
  }

  return false
}

function getCurrentUser() {
  return new Promise((resolve) => {
    var unsubscribe = getAuth().onAuthStateChanged((user) => {
      resolve(user)
      unsubscribe()
    })
  })
}
